export default {
  aboutUserId: {}
};
